module.exports = __webpack_public_path__ + "img/icon_FAQ_settings_inactive.bf01a5e2.svg";